export default {
  add_items: 'Aggiungi articoli',
  remove_items: 'Rimuovi articoli',
  place_order: 'Effettua ordine',
  proceed_to_payment: 'Continua al pagamento',
  go_to_menu: 'Vai al menu',

  toasts: {
    input_errors_found: 'Ci sono alcuni problemi con le informazioni del tuo ordine',
  },

  error_messages: {
    internal_error: {
      title: 'Ordine non riuscito 😔',
      description:
        'Purtroppo si è verificato un problema inatteso con il tuo ordine, il nostro team tecnico è già al lavoro 🛠️.',
    },
  },
};
